import type { User } from '@vtblife/event-bus-events';
import type { UpdateTargetingAttributesParam } from '@vtblife/growthbook';

import { isAnonymousUser } from '../utils';

export function userToUpdateTargetingAttributes(user: User | null | undefined): UpdateTargetingAttributesParam {
    let updateAttributes: UpdateTargetingAttributesParam = {
        user: {
            id: undefined,
            currentRoleType: undefined,
            permissions: undefined,
            companyId: undefined,
            franchise: undefined,
        },
    };

    if (user && !isAnonymousUser(user.userId) && user.userId) {
        updateAttributes = {
            user: {
                id: { value: user.userId },
                currentRoleType: { value: user.currentRoleType },
                permissions: { value: user.permissions },
                companyId: { value: user.companyId ?? undefined },
                franchise: { value: user.franchise },
            },
        };
    }

    return updateAttributes;
}
